import React from 'react';
import * as translations from './strings';
import styles from './index.module.css';
import { getLangKey } from '../../models/Language';
import { Button } from 'antd';
import HelpArticleButton from '../../utils/HelpArticleButton';
const strings = translations[getLangKey()];

type Props = {
  handleEnableBeta: () => void;
};

export const AIBetaOptIn = ({ handleEnableBeta }: Props) => {
  return (
    <div className={styles.aiBetaOptInContainer}>
      <div className={styles.aiBetaOptInContent}>
        <h3 className={styles.aiBetaOptInTitle}>
          {strings.betaOptInTitle}
          <HelpArticleButton articleId={12686483} style={{ marginLeft: 8 }} />
        </h3>
        <p className={styles.aiBetaOptInDescription}>
          {strings.betaOptInDescription}
        </p>
      </div>
      <Button
        type="primary"
        className={styles.enableBeta}
        onClick={handleEnableBeta}
      >
        {strings.enableBeta}
      </Button>
    </div>
  );
};
